import React from "react";

const RightArrowReadMoreIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Styleguide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Assets" transform="translate(-424.000000, -40.000000)" fill="#000000" fillRule="nonzero" stroke="#000000">
        <g id="Icons/Read-More" transform="translate(424.000000, 40.000000)">
          <g id="arrow_forward_FILL0_wght400_GRAD0_opsz48" transform="translate(4.615385, 4.615385)">
            <polygon
              id="Path"
              points="7.38461538 14.7692308 6.41538462 13.7769231 12.1153846 8.07692308 0 8.07692308 0 6.69230769 12.1153846 6.69230769 6.41538462 0.992307692 7.38461538 0 14.7692308 7.38461538"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default RightArrowReadMoreIcon;
